import React from "react";
import { Row, Col, InputNumber, Switch, Divider } from "antd";

const BatteryConfig = ({ fields, setField }) => (
  <div className="pt-2">
    <Row gutter={16} className="mb-3 align-items-center">
      <Col span={14}>
        <label className="font-weight-bold">電量警報門檻 (%)</label>
        <div className="text-muted small">低於此電量時觸發警報</div>
      </Col>
      <Col span={10}>
        <InputNumber
          style={{ width: "100%" }}
          min={1}
          max={99}
          value={fields.battery_alert_level}
          onChange={(v) => setField("battery_alert_level", v)}
          addonAfter="%"
        />
      </Col>
    </Row>

    <Divider />

    <Row gutter={16} className="mb-2">
      <Col span={10} />
      <Col span={4} className="text-center">
        <span className="text-muted small">偵測啟動</span>
      </Col>
      <Col span={10}>
        <span className="text-muted small">冷卻時間</span>
      </Col>
    </Row>
    <Row gutter={16} className="align-items-center">
      <Col span={10}>
        <label className="font-weight-bold">電量不足警報</label>
      </Col>
      <Col span={4} className="text-center">
        <Switch
          checked={fields.battery_low_enabled}
          onChange={(v) => setField("battery_low_enabled", v)}
        />
      </Col>
      <Col span={10}>
        <InputNumber
          style={{ width: "100%" }}
          min={60}
          max={86400}
          step={60}
          value={fields.battery_low_cooldown_seconds}
          onChange={(v) => setField("battery_low_cooldown_seconds", v)}
          addonAfter="秒"
        />
      </Col>
    </Row>
  </div>
);

export default BatteryConfig;
